module.exports = __webpack_public_path__ + "static/gif.45576aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/capabilities-view/whatsapp/gif.jpg
// module id = 262
// module chunks = 179175873700456 190794081531305 235131596041995